import React from 'react'
import PropTypes from 'prop-types'

const Clipboard = ({ customClassName, width, height, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Clipboard"
    viewBox="0 0 431.998 431.998"
    style={{ enableBackground: 'new 0 0 431.998 431.998', }}
  >
    <title id="clipboard-icon">Clipboard</title>
    <g><g><rect x="80.102" y="192" width="192" height="16" /></g></g>
    <g><g><polygon points="80.102,239.998 80.102,255.998 235.816,255.998 251.816,239.998" /></g></g>
    <g><g><polygon points="80.102,287.998 80.102,303.998 187.813,303.998 203.814,287.998" /></g></g>
    <g><g><rect x="80.102" y="336" width="80" height="16" /></g></g>
    <g>
      <g>
        <path d="M411.213,171.106l-22.628-22.626c-6.245-6.245-16.382-6.246-22.627-0.001c-57.747,57.747-115.648,115.648-173.855,173.854
          c0,27.687,0,21.689,0,45.662c38.518,0,28.774,0.018,44.915-0.068c8.351-8.351,45.207-45.206,83.085-83.083v115.154
          c0,8.836-7.163,16-16,16h-256c-8.837,0-16-7.164-16-16v-288c0-8.837,7.163-16,16-16h32.003v32.001h191.997v-32l32-0.001
          c8.837,0,16,7.163,16,16v59.426l16-16.111v-43.315c0-17.674-14.327-32-32-32h-34.764c-5.138-14.522-17.041-25.849-31.944-30.134
          c-7.367-2.118-13.037-7.788-15.156-15.155C216.474,14.663,198.001,0,176.102,0c-21.898,0-40.37,14.663-46.134,34.706
          c-2.122,7.376-7.806,13.039-15.181,15.164c-14.897,4.293-26.81,15.608-31.942,30.128H48.102c-17.673,0-32,14.326-32,32v288
          c0,17.673,14.327,32,32,32h256c17.673,0,32-14.327,32-32V268.845c34.399-34.398,66.437-66.437,75.11-75.111
          C417.457,187.488,417.457,177.351,411.213,171.106z M96.104,95.742c0.11-14.066,9.614-26.606,23.112-30.496
          c12.71-3.662,22.478-13.426,26.128-26.116C149.261,25.51,161.909,16,176.102,16c14.194,0,26.842,9.51,30.758,23.13
          c3.652,12.698,13.413,22.459,26.111,26.11c13.618,3.918,23.13,16.566,23.13,30.759v16H96.104V95.742z M230.352,351.965
          c-4.149,0.023-5.848,0.03-11.589,0.032l-10.661-10.661v-12.375c3.966-3.966,6.709-6.709,10.778-10.778l22.627,22.627
          L230.352,351.965z M252.82,329.497l-22.627-22.627l101.824-101.823l22.627,22.628L252.82,329.497z M365.957,216.36l-22.627-22.627
          l11.314-11.314l22.628,22.627L365.957,216.36z M388.585,193.734l-22.628-22.628l11.314-11.313l22.628,22.627L388.585,193.734z"
        />
      </g>
    </g>
    <g><g><circle cx="176.342" cy="48" r="12" /></g></g>
  </svg>)

Clipboard.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  customClassName: PropTypes.string,
}

Clipboard.defaultProps = {
  width: 20,
  height: undefined,
  customClassName: '',
}

export default Clipboard



// WEBPACK FOOTER //
// ./src/components/icons/Clipboard.js